/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */
import Descriptor, { IDescriptorBody } from '../../descriptor';

export interface ICommentThreadAddedCommentJSON {
	commentId: string;
	createdAt: string;
}

export interface ICommentThreadAddedComment {
	commentId: string;
	createdAt: Date;
}

export default class CommentThreadAddedCommentDescriptor extends Descriptor {
	public static readonly DESCRIPTOR_NAME: string = 'CommentThreadAddedCommentDescriptor';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentId: {
				id: 1,
				type: 'string'
			},
			createdAt: {
				id: 2,
				type: 'string'
			}
		}
	};

	public static toJSON( comment: ICommentThreadAddedComment ): ICommentThreadAddedCommentJSON {
		return {
			commentId: comment.commentId,
			createdAt: comment.createdAt?.toISOString()
		};
	}

	public static fromJSON( comment: ICommentThreadAddedCommentJSON ): ICommentThreadAddedComment {
		return {
			commentId: comment.commentId,
			createdAt: new Date( comment.createdAt )
		};
	}
}
